/* CAUDEX theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  const C = window.Caudex || { routes: {}, strings: {} };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#CaudexToast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => { el.hidden = true; }, 400);
    }, 3200);
  }

  /* ---------------- Drawers & modals ---------------- */
  let lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('input[type="search"], [data-autofocus], button, a');
    if (f) setTimeout(() => f.focus(), 120);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-modal.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) {
        if (opener.dataset.open === 'CartDrawer' && C.cartType !== 'drawer') return;
        e.preventDefault();
        openPanel(target);
      }
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closePanel(closer.closest('.drawer, .search-modal, .lightbox'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .search-modal.is-open, .lightbox.is-open').forEach(closePanel);
  });

  /* ---------------- Header ---------------- */
  function initHeader() {
    const wrap = $('.header-wrapper');
    if (!wrap) return;
    const hideOnScroll = wrap.dataset.hideOnScroll === 'true';
    const section = wrap.closest('.section-header');
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      wrap.classList.toggle('is-stuck', y > 40);
      if (section) section.classList.toggle('is-stuck', y > 40);
      if (hideOnScroll) wrap.classList.toggle('is-hidden', y > last && y > 300 && !$('.nav li:hover', wrap));
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Predictive search ---------------- */
  function initSearch() {
    const input = $('[data-predictive-input]');
    const out = $('[data-predictive-results]');
    if (!input || !out || !C.routes.predictive_search) return;
    let ctrl, timer;
    const esc = (s) => String(s || '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${C.routes.predictive_search}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last`;
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const r = data.resources.results;
          let html = '';
          if (r.products && r.products.length) {
            html += '<ul class="predictive__list">' + r.products.map((p) => `
              <li><a class="predictive__item" href="${esc(p.url)}">
                ${p.image ? `<img src="${esc(p.image)}&width=160" alt="" loading="lazy" width="70" height="86">` : ''}
                <span><span class="predictive__title">${esc(p.title)}</span><br>
                <span class="predictive__meta">${esc(p.vendor || '')}${p.price ? ' · ' + esc(input.dataset.currency || '') + ' ' + esc(p.price) : ''}</span></span>
              </a></li>`).join('') + '</ul>';
          }
          if (r.collections && r.collections.length) {
            html += '<p class="eyebrow" style="margin-top:3rem">Collections</p><ul class="predictive__list">' + r.collections.map((c) => `<li><a class="predictive__item" href="${esc(c.url)}"><span class="predictive__title">${esc(c.title)}</span></a></li>`).join('') + '</ul>';
          }
          if (!html) html = `<p class="text-muted">${esc(input.dataset.noResults || 'No results')}</p>`;
          html += `<div class="predictive__all"><a class="link" href="${C.routes.root.replace(/\/$/, '')}/search?q=${encodeURIComponent(q)}&type=product">${esc(input.dataset.viewAll || 'View all results')}</a></div>`;
          out.innerHTML = html;
        } catch (err) { /* aborted */ }
      }, 220);
    });
  }

  /* ---------------- Cart ---------------- */
  async function refreshCart(open) {
    try {
      const res = await fetch(`${C.routes.root.replace(/\/$/, '')}/?sections=cart-drawer`);
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-inner]');
        const cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      const cart = await (await fetch(`${C.routes.cart}.js`)).json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      if (open && C.cartType === 'drawer') openPanel($('#CartDrawer'));
      return cart;
    } catch (e) { console.error(e); }
  }

  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    try {
      const res = await fetch(`${C.routes.cart_add}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        toast(data.description || data.message || C.strings.error);
      } else if (C.cartType === 'drawer') {
        await refreshCart(true);
      } else {
        await refreshCart(false);
        toast(C.strings.added);
      }
    } catch (e) {
      form.submit();
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  async function changeLine(line, quantity) {
    const drawer = $('[data-cart-drawer-inner]');
    if (drawer) drawer.style.opacity = '.5';
    await fetch(`${C.routes.cart_change}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    await refreshCart(false);
    if (drawer) drawer.style.opacity = '';
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm && rm.closest('[data-cart-drawer-inner]')) { e.preventDefault(); changeLine(+rm.dataset.line, 0); return; }
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    e.preventDefault();
    const wrap = step.closest('.qty');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const min = +input.min || 0;
    const max = input.max ? +input.max : Infinity;
    const v = Math.min(max, Math.max(min, (+input.value || 0) + (+step.dataset.qtyStep)));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    if (input.closest('[data-cart-drawer-inner]')) changeLine(+input.dataset.line, +input.value);
    else if (input.form) input.form.submit();
  });

  /* ---------------- Product ---------------- */
  function initProduct(root) {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = { variants: JSON.parse(dataEl.textContent) };
    const form = root.querySelector('form[data-product-form]');
    const idInput = form && form.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const availEl = root.querySelector('[data-availability]');
    const addBtn = root.querySelector('[data-add-button]');
    const stickyPrice = $('[data-sticky-price]');
    const stickyBtn = $('[data-sticky-add]');

    const pickers = $$('[data-option-index]', root);
    function currentOptions() {
      return pickers.map((fs) => {
        const sel = fs.querySelector('select');
        if (sel) return sel.value;
        const c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      const opts = currentOptions();
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = C.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      const priceHtml = v.on_sale
        ? `<span class="price__sale">${v.price}</span><s class="price__compare">${v.compare}</s>`
        : `<span>${v.price}</span>`;
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyPrice) stickyPrice.innerHTML = v.price;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector('span').textContent = v.available ? C.strings.addToCart : C.strings.soldOut;
      }
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (availEl) {
        const inv = availEl.dataset;
        availEl.classList.remove('availability--low', 'availability--out');
        if (!v.available) { availEl.classList.add('availability--out'); availEl.querySelector('span:last-child').textContent = inv.out; }
        else { availEl.querySelector('span:last-child').textContent = inv.in; }
      }
      if (v.media_id) {
        const slide = root.querySelector(`[data-media-id="${v.media_id}"]`);
        if (slide) goToSlide(root, slide);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    pickers.forEach((fs) => fs.addEventListener('change', update));

    // sticky ATC
    const sticky = $('.sticky-atc');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', () => { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  function goToSlide(root, slide) {
    const track = root.querySelector('.gallery__main');
    if (!track) return;
    if (getComputedStyle(track).gridAutoFlow.indexOf('column') > -1) {
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    } else {
      slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function initGallery(root) {
    const track = root.querySelector('.gallery__main');
    if (!track) return;
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('.gallery__thumb', root);
    const counter = root.querySelector('[data-gallery-counter]');
    thumbs.forEach((t, i) => t.addEventListener('click', () => goToSlide(root, slides[i])));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
        if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
      });
    }, { passive: true });

    // Lightbox
    const lb = $('#Lightbox');
    if (!lb) return;
    const img = lb.querySelector('img');
    const imgs = slides.map((s) => s.querySelector('img[data-zoom]')).filter(Boolean);
    let idx = 0;
    const show = (i) => { idx = (i + imgs.length) % imgs.length; img.src = imgs[idx].dataset.zoom; img.alt = imgs[idx].alt; };
    imgs.forEach((im, i) => im.closest('.media').addEventListener('click', () => { show(i); openPanel(lb); }));
    const prev = lb.querySelector('[data-lb-prev]');
    const next = lb.querySelector('[data-lb-next]');
    if (prev) prev.addEventListener('click', () => show(idx - 1));
    if (next) next.addEventListener('click', () => show(idx + 1));
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* ---------------- Sliders ---------------- */
  function initSliders(scope) {
    $$('[data-slider]', scope).forEach((wrap) => {
      const track = wrap.querySelector('.product-slider');
      if (!track) return;
      const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 24 : 300);
      const p = wrap.querySelector('[data-slide-prev]');
      const n = wrap.querySelector('[data-slide-next]');
      if (p) p.onclick = () => track.scrollBy({ left: -step(), behavior: 'smooth' });
      if (n) n.onclick = () => track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  }

  /* ---------------- Facets ---------------- */
  function initFacets() {
    $$('form[data-facets]').forEach((form) => {
      const apply = () => {
        const params = new URLSearchParams(new FormData(form));
        for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
        const sort = $('[data-sort-select]');
        if (sort && sort.value) params.set('sort_by', sort.value);
        window.location.search = params.toString();
      };
      form.addEventListener('change', (e) => { if (e.target.type === 'checkbox' && form.dataset.autoApply === 'true') apply(); });
      form.addEventListener('submit', (e) => { e.preventDefault(); apply(); });
    });
    const sort = $('[data-sort-select]');
    if (sort) sort.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sort.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  }

  /* ---------------- Reveal ---------------- */
  function initReveal(scope) {
    const els = $$('.reveal, .reveal-img', scope);
    if (!document.body.classList.contains('has-animations') || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------------- Share ---------------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    e.preventDefault();
    const url = b.dataset.url || window.location.href;
    if (navigator.share) { try { await navigator.share({ title: document.title, url }); } catch (_) {} return; }
    try { await navigator.clipboard.writeText(url); toast(b.dataset.copied || 'Link copied'); } catch (_) {}
  });

  /* ---------------- Address forms (customer) ---------------- */
  function initAddresses() {
    $$('[data-address-toggle]').forEach((b) => b.addEventListener('click', () => {
      const t = document.getElementById(b.dataset.addressToggle);
      if (t) t.hidden = !t.hidden;
    }));
    $$('[data-address-delete]').forEach((b) => b.addEventListener('click', () => {
      if (window.confirm(b.dataset.confirm || 'Delete this address?')) {
        const f = document.createElement('form');
        f.method = 'post'; f.action = b.dataset.addressDelete;
        f.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(f); f.submit();
      }
    }));
    if (window.Shopify && Shopify.CountryProvinceSelector) {
      $$('[data-country-select]').forEach((sel) => {
        new Shopify.CountryProvinceSelector(sel.id, sel.dataset.provinceId, { hideElement: sel.dataset.provinceWrap });
      });
    }
  }

  /* ---------------- Recommendations ---------------- */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(async (el) => {
      if (!el.dataset.url) return;
      try {
        const html = await (await fetch(el.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations-inner]');
        if (fresh && fresh.querySelector('.card')) {
          el.querySelector('[data-recommendations-inner]').innerHTML = fresh.innerHTML;
          initReveal(el);
        }
      } catch (_) { /* keep fallback */ }
    });
  }

  /* ---------------- Init ---------------- */
  function init(scope = document) {
    initRecommendations(scope);
    initReveal(scope);
    initSliders(scope);
    $$('[data-product-root]', scope).forEach((r) => { initProduct(r); initGallery(r); });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initSearch();
    initFacets();
    initAddresses();
    init();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const d = e.target.querySelector('.drawer');
    if (d) openPanel(d);
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const d = e.target.querySelector('.drawer');
    if (d) closePanel(d);
  });
})();
